import type { App } from "vue";
import { addDynamicImportBreadcrumb, captureException, initSentry } from "@/services/analytics/sentry";

export default {
  install(app: App) {
    initSentry(app);

    app.config.errorHandler = (err, _instance, info) => {
      captureException(err);
      console.error("[Vue]", info, err);
    };

    window.addEventListener("unhandledrejection", (event) => {
      captureException(event.reason);
    });

    // Vite wraps every dynamic import() (route views and defineAsyncComponent components alike) through
    // its own runtime helper, which dispatches this event on failure. Actual recovery happens locally via
    // router.onError (see dynamicImportRecovery.ts) and useAsyncComponent - this is purely a centralized
    // observability tap, so it must not call preventDefault(): doing so would swallow the rejection and
    // stop those local recovery handlers from ever running.
    window.addEventListener("vite:preloadError", (event) => {
      addDynamicImportBreadcrumb((event as Event & { payload: unknown }).payload);
    });
  },
};
